import { Component } from "@angular/core";

// Component used for changing the route without reloading the page. 
// This is used for changing the language on all components.
@Component({
    template: '',
    selector: 'app-reload',
})
export class ReloadComponent {
}